export default (state = [], action) => {
    switch (action.type) {
        case 'MATCHES_FETCH_SUCCESS':
            return action.matches;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/matchReducers.js